import React, { useMemo } from 'react';
import { styled } from '@linaria/react';
import { useDeviceLayout } from '@vio/atlas/context/deviceLayout';
import ContentWrapper from '@vio/atlas/helpers/ContentWrapper';
import { Flex } from '@vio/atlas/helpers/Flex';
import { Text } from '@vio/atlas/Text';
import { SearchFormDesktop } from 'components/SearchBox/Home/SearchFormDesktop';
import { SearchFormMobile } from 'components/SearchBox/Home/SearchFormMobile';
import { useBrand } from '@daedalus/core/src/_web/brand/hooks/useBrand';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
import { HighlightedTitle } from '../HighlightedTitle';
import { TrustpilotDetails } from '../TrustpilotDetails';
import { SocialProof } from './SocialProof';
import { cx } from '@linaria/core';
import { AlternativeDesktopSearchForm } from './AlternativeDesktopSearchForm';
const Wrapper = /*#__PURE__*/styled('section')({
  name: "Wrapper",
  class: "w1x7ckov",
  propsAsIs: false
});
const Object1 = /*#__PURE__*/styled('div')({
  name: "Object1",
  class: "o17kzof1",
  propsAsIs: false
});
const Object2 = /*#__PURE__*/styled('div')({
  name: "Object2",
  class: "odxudnx",
  propsAsIs: false
});
const Object3 = /*#__PURE__*/styled('div')({
  name: "Object3",
  class: "o1ps789k",
  propsAsIs: false
});
const BackgroundCover = /*#__PURE__*/styled('div')({
  name: "BackgroundCover",
  class: "b12log7t",
  propsAsIs: false
});
const _exp9 = /*#__PURE__*/() => Flex.Column;
const ContentContainer = /*#__PURE__*/styled(_exp9())({
  name: "ContentContainer",
  class: "c1urqhev",
  propsAsIs: true
});
const _exp14 = /*#__PURE__*/() => Flex.Row;
const SearchFormMobileWrapper = /*#__PURE__*/styled(_exp14())({
  name: "SearchFormMobileWrapper",
  class: "sf8kwa2",
  propsAsIs: true
});
const SearchFormDesktopWrapper = /*#__PURE__*/styled('div')({
  name: "SearchFormDesktopWrapper",
  class: "svoqflj",
  propsAsIs: false
});
export const HeroSection = () => {
  const {
    brandHasAlternativeSearchForm,
    brandIsKiwi,
    brandIsVio,
    brandHomepageHeadingMessage,
    brandHomepageSubheadingMessage
  } = useBrand();
  const {
    isMobile,
    isDesktopXs
  } = useDeviceLayout();
  const title = useMemo(() => {
    if (brandIsVio) return <HighlightedTitle source="HeroSection" />;
    if (brandHomepageHeadingMessage) return <FormattedMessageWrapper {...brandHomepageHeadingMessage} />;
  }, [brandIsVio, brandHomepageHeadingMessage]);
  const subtitle = useMemo(() => {
    if (brandIsVio) return <FormattedMessageWrapper id="homePage.heroSubtitle" defaultMessage="Join millions of happy travelers and find the best accommodation deals" />;
    if (!brandIsKiwi && brandHomepageSubheadingMessage) return <FormattedMessageWrapper {...brandHomepageSubheadingMessage} />;
  }, [brandIsVio, brandIsKiwi, brandHomepageSubheadingMessage]);
  if (isMobile) return <Wrapper data-id="HeroSection">
        <ContentContainer justifyContent="flex-start" gap="s500">
          <ContentWrapper paddingTop="s800" paddingX="s500">
            <Flex.Column justifyContent="center" gap="s200">
              <Text variant="title2XL" dataId="HomeHeading">
                {title}
              </Text>
              <Text variant="bodyM">{subtitle}</Text>
            </Flex.Column>
          </ContentWrapper>
          <SearchFormMobileWrapper justifyContent="center" alignItems="center" className={cx(brandIsVio && '__isVio')}>
            <SearchFormMobile />
          </SearchFormMobileWrapper>
          {brandIsVio && <TrustpilotDetails section="Hero" />}
        </ContentContainer>
      </Wrapper>;
  if (!isMobile && brandHasAlternativeSearchForm) {
    return <AlternativeDesktopSearchForm />;
  }
  if (isDesktopXs) return <Wrapper data-id="HeroSection">
        {brandIsVio && <>
            <Object1 />
            <Object2 />
            <Object3 />
            <BackgroundCover />
          </>}
        <ContentContainer alignItems="center" gap="s700" justifyContent={brandIsVio ? 'flex-start' : 'center'} className={cx(brandIsVio && '__isVio')}>
          <Flex.Column alignItems="center" justifyContent="center" gap="s200">
            <Text align="center" variant="title5XL" dataId="HomeHeading">
              {title}
            </Text>
            <Text align="center" variant="bodyL">
              {subtitle}
            </Text>
          </Flex.Column>

          <SearchFormMobileWrapper justifyContent="center" alignItems="center" className={cx(brandIsVio && '__isVio')}>
            <SearchFormMobile />
          </SearchFormMobileWrapper>
          {brandIsVio && <SocialProof />}
        </ContentContainer>
      </Wrapper>;
  return <Wrapper data-id="HeroSection" className={cx(brandIsVio && '__isVio')}>
      {brandIsVio && <>
          <Object1 />
          <Object2 />
          <Object3 />
          <BackgroundCover />
        </>}
      <ContentContainer justifyContent={brandIsVio ? 'space-between' : 'center'} className={cx(brandIsVio && '__isVio')}>
        <Flex.Column justifyContent="flex-start" gap="s900">
          <Flex.Column alignItems="center" justifyContent="center" gap="s200">
            <Text align="center" variant="title5XL" dataId="HomeHeading">
              {title}
            </Text>
            <Text align="center" variant="bodyL">
              {subtitle}
            </Text>
          </Flex.Column>

          <SearchFormDesktopWrapper className={cx(brandIsVio && '__isVio')}>
            <SearchFormDesktop />
          </SearchFormDesktopWrapper>
        </Flex.Column>
        {brandIsVio && <SocialProof />}
      </ContentContainer>
    </Wrapper>;
};

require("./HeroSection.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./HeroSection.tsx");